import Label from '@material-ui/icons/Label';

import List from './List';

export default { list: List, icon: Label };
